"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const InnerForm_1 = __importDefault(require("@Fields/v2/InnerForm"));
const CreatePublisherDetails = (props) => {
    const { publisherName, ipiNumber, isAdministrator } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h5", { className: 'medium subtitle' },
            "Enter the ",
            isAdministrator ? 'administrator' : 'publisher',
            "'s details."),
        react_1.default.createElement("h5", { className: 'medium subtitle' }, "The Create Publisher button is only for Members who intend to list their Member name as the administrator on behalf of a publisher."),
        react_1.default.createElement(InnerForm_1.default, { formFields: { publisherName, ipiNumber } }),
        react_1.default.createElement("p", null,
            "If your Member name is not your publisher name and needs to be updated, please click",
            ' ',
            react_1.default.createElement(react_router_dom_1.NavLink, { className: "Link", to: navigation_1.default.contactUs.root(), target: '_blank', rel: "noopener noreferrer" },
                "here",
                ' '),
            "to contact Support.")));
};
exports.default = CreatePublisherDetails;
